import {axiosAPI} from "./API";
import { UserService } from "./UserService";

// Singleton for interacting with replay events
class _MessageService {

    socket: WebSocket;

    public subscribe = async (uuid: string): Promise<WebSocket> => {

        // let url = axiosAPI.defaults.baseURL; // take url from axios
        // url = url.replace("caprep", "websocket-caprep"); // replace url prefix
        // url += "?auth=" + UserService.oktaUserInfo.token; // add token param

        // TODO - fix route53 reference
        let url = "wss://n47xguaf14.execute-api.us-east-1.amazonaws.com/v0?auth=" + UserService.oktaUserInfo.token;

        this.socket = new WebSocket(url);

        this.socket.addEventListener("open", event => {
            this.socket.send(`{"action":"subscribe","subscriptions":["${uuid}"]}`);
            console.log("connected to events");
        });

        this.socket.addEventListener("close", event => {
            console.log("disconnected from events");
        });

        return this.socket;
    }

    public disconnect = () => {
        this.socket.close();
    }
}

export const MessageService = new _MessageService();
